// extracted by mini-css-extract-plugin
export default {"row":"documents-list_row__1tB0Y","micromag":"documents-list_micromag__2AiAu","video":"documents-list_video__15HGu","article":"documents-list_article__1nanU"};